import React from 'react';
import { Sparkles, X, Loader2, Send } from 'lucide-react';
interface ChartAiEditPanelProps {
  aiPrompt: string;
  setAiPrompt: (v: string) => void;
  aiResult: string;
  aiLoading: boolean;
  onSubmit: () => void;
  onClose: () => void;
}
export function ChartAiEditPanel({
  aiPrompt,
  setAiPrompt,
  aiResult,
  aiLoading,
  onSubmit,
  onClose
}: ChartAiEditPanelProps) {
  return <div className="absolute inset-x-4 top-14 z-[200] pointer-events-auto" data-id="element-1058">
      <div className="rounded-2xl shadow-2xl shadow-black/50 border border-white/[0.08] overflow-hidden" style={{
      background: 'rgba(15, 23, 42, 0.92)',
      backdropFilter: 'blur(40px) saturate(180%)',
      WebkitBackdropFilter: 'blur(40px) saturate(180%)'
    }} data-id="element-1059">
        <div className="absolute inset-0 rounded-2xl pointer-events-none" style={{
        background: 'linear-gradient(135deg, rgba(255,255,255,0.06) 0%, transparent 50%, rgba(255,255,255,0.02) 100%)'
      }} data-id="element-1060" />
        <div className="relative flex items-center justify-between px-4 py-3 border-b border-white/[0.06]" data-id="element-1061">
          <div className="flex items-center gap-2" data-id="element-1062">
            <Sparkles size={14} className="text-[#EC4899]" data-id="element-1063" />
            <span className="text-sm font-semibold text-white/90" data-id="element-1064">
              Edit with AI
            </span>
          </div>
          <button onClick={onClose} className="p-1 text-white/40 hover:text-white/80 hover:bg-white/[0.08] rounded-md transition-colors" data-id="element-1065">
            <X size={14} data-id="element-1066" />
          </button>
        </div>
        <div className="relative p-4 space-y-3" data-id="element-1067">
          <p className="text-xs text-slate-400" data-id="element-1068">
            Describe what you'd like to change — variable, region, time period,
            or models.
          </p>
          <textarea autoFocus value={aiPrompt} onChange={e => setAiPrompt(e.target.value)} onKeyDown={e => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            onSubmit();
          }
        }} placeholder="e.g. Switch to temperature for Germany over 7 days, or show EPT-2 and GFS..." rows={2} className="w-full bg-white/[0.04] border border-white/[0.08] rounded-xl px-3 py-2.5 text-sm text-white/90 placeholder:text-white/25 focus:outline-none focus:border-[#EC4899]/40 focus:ring-1 focus:ring-[#EC4899]/10 resize-none" data-id="element-1069" />
          {aiResult && <div className="bg-white/[0.04] border border-white/[0.06] rounded-xl p-3" data-id="element-1070">
              <div className="flex items-center gap-1.5 mb-1.5" data-id="element-1071">
                <Sparkles size={10} className="text-[#EC4899]" data-id="element-1072" />
                <span className="text-[10px] font-semibold text-[#EC4899] uppercase tracking-wider" data-id="element-1073">
                  Athena
                </span>
              </div>
              <p className="text-xs text-white/70 leading-relaxed" data-id="element-1074">
                {aiResult}
              </p>
            </div>}
          <div className="flex justify-end" data-id="element-1075">
            <button onClick={onSubmit} disabled={!aiPrompt.trim() || aiLoading} className="flex items-center gap-2 px-4 py-2 rounded-lg bg-[#EC4899] hover:bg-[#db2777] text-white text-xs font-medium shadow-lg shadow-pink-900/20 disabled:opacity-40 disabled:cursor-not-allowed transition-colors" data-id="element-1076">
              {aiLoading ? <>
                  <Loader2 size={12} className="animate-spin" data-id="element-1077" />
                  Thinking...
                </> : <>
                  <Send size={12} data-id="element-1078" />
                  Apply
                </>}
            </button>
          </div>
        </div>
      </div>
    </div>;
}